/**
 * @description 重要操作记录 importantOperation
 * @author xiehan
 * @date 2020/02/19
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const importantOperationBiz = new Logic()

importantOperationBiz.delete = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.importantOperation.delete,
    data: data
  })
}

importantOperationBiz.deleteBatch = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.importantOperation.deleteBatch,
    data: data
  })
}

importantOperationBiz.query = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.importantOperation.query,
    data: data
  })
}

importantOperationBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.importantOperation.save,
    data: data
  })
}

importantOperationBiz.update = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.importantOperation.update,
    data: data
  })
}

/**
 * Created by xiehan on 2020/02/19.
 * 重要操作记录
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
importantOperationBiz.export = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.importantOperation.query,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    isJson: 0
  })
  exportTable.send(success, fail)
}

export default importantOperationBiz
